/**
 * Check and return true if an object not undefined or null
 */
export function isPresent(obj) {
    return obj !== undefined && obj !== null;
}



//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/ng2-slim-loading-bar/src/slim-loading-bar.utils.js
// module id = ../../../../ng2-slim-loading-bar/src/slim-loading-bar.utils.js
// module chunks = 13